import { Select } from "../../ui/Select";
import { Input } from "../../ui/Input";
import { Textarea } from "../../ui/Textarea";
import { SearchableSelect } from "../../ui/SearchableSelectReact";
const prefixId = "P-"
export const PropertyInfoForm = ({
  formData,
  existingProperty,
  handleChange,
  handlePropertyChange,
  isReadOnly,
  countries,
  handleUpdate,
  isSelectorReadOnly,
  isReport,
}) => {

  const displayId = (id) => {
    if (!id || id === 0) return ""
    return prefixId + (1000000000 + id).toString()
  }


  return (

    <form onSubmit={handleUpdate}>
 <div className="top-section">
  <h2>Property Information</h2>
      {!isReport && <Select
        label="Quick Fill Existing Property:"
        name="propertyId"
        value={formData.propertyId}
        options={
          existingProperty && existingProperty.length > 0
            ? existingProperty
              .filter((value) => value != null)
              .map((value) => parseInt(value))
              .sort((a, b) => b - a)
              .map((value) => ({
                value,
                display_value: value,
              }))
            : [{ value: "", display_value: "No properties available" }]
        }
        onChange={handlePropertyChange}
        disabled={isSelectorReadOnly|| isReadOnly}
       
      />}

      <Input
        label="Property ID"
        name="propertyId"
        type="text"
        value={formData.propertyId}
        placeholder={"Auto Generated"}
        onChange={handleChange}
        disabled={true}
        isReport={isReport}
      />
      <Input
        label="Property Status"
        name="propertyStatus"
        type="text"
        value={formData.propertyStatus}
        disabled={true}
        isReport={isReport}
      />
</div>
<div className="bottom-section">
      <Input
        label="Property Name"
        name="propertyName"
        type="text"
        value={formData.propertyName}
        onChange={handleChange}
        disabled={isReadOnly}
        required
        isReport={isReport}
      />

      <Input
        label="Address Line 1"
        name="addressLine1"
        type="text"
        value={formData.addressLine1}
        onChange={handleChange}
        disabled={isReadOnly}
        required
        isReport={isReport}
      />

      <Input
        label="Address Line 2"
        name="addressLine2"
        type="text"
        value={formData.addressLine2}
        onChange={handleChange}
        disabled={isReadOnly}
        isReport={isReport}
      />

      <Input
        label="Address Line 3"
        name="addressLine3"
        type="text"
        value={formData.addressLine3}
        onChange={handleChange}
        disabled={isReadOnly}
        isReport={isReport}
      />

      <Input
        label="City"
        name="city"
        type="text"
        value={formData.city}
        onChange={handleChange}
        disabled={isReadOnly}
        required
        isReport={isReport}
      />

      <Input
        label="County/State"
        name="state"
        type="text"
        value={formData.state}
        onChange={handleChange}
        disabled={isReadOnly}
        isReport={isReport}
      />

      <Input
        label="Postcode"
        name="postcode"
        type="text"
        value={formData.postcode}
        onChange={handleChange}
        disabled={isReadOnly}
        required
        isReport={isReport}
      />

      <SearchableSelect
  label="Country"
  name="country"
  value={formData.country}
  options={countries.map((country) => ({
    value: country,
    display_value: country,
  }))}
  onChange={handleChange}
  disabled={isReadOnly}
  required
  isReport={isReport}
/>

      {formData.country === "United Kingdom" && (
        <>
          <h3 className="subhead">
            <span>
              UK Land Registry Property Information
              <span style={{ fontSize: "12px", fontWeight: "normal", color: "#ffffff", marginLeft: "10px" }}>
                NOTE: Your regulator expects this information to be included.
              </span>
            </span>
          </h3>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "8px" }}>
            <a
              href="https://www.gov.uk/search-property-information-land-registry"
              target="_blank"
              rel="noreferrer"
              style={{
                fontSize: "13px",
                fontWeight: "500",
                color: "#ffffff",
                backgroundColor: "#07b1b0",
                padding: "6px 14px",
                borderRadius: "4px",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              Land Registry ↗
            </a>
          </div>
          <Input
            label="Title Number(s)"
            name="titleNumbers"
            type="text"
            value={formData.titleNumbers}
            onChange={handleChange}
            disabled={isReadOnly}
            isReport={isReport}
          />
          <Textarea
            label="Registration Description"
            name="registrationDescription"
            value={formData.registrationDescription}
            onChange={handleChange}
            disabled={isReadOnly}
            isReport={isReport}
          />
        </>
      )}
</div>
    </form>
  );
};
